import { render, staticRenderFns } from "./CategorySelection.vue?vue&type=template&id=630cc4b8&scoped=true&"
import script from "./CategorySelection.vue?vue&type=script&lang=js&"
export * from "./CategorySelection.vue?vue&type=script&lang=js&"
import style0 from "./CategorySelection.vue?vue&type=style&index=0&id=630cc4b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630cc4b8",
  null
  
)

export default component.exports